import React, { Component } from 'react';

export default class MobileMenu extends Component {
    render() {
        return (
            <div id="mobile-menu" className={`global--mobile-menu ${this.props.isOpen ? 'is-open' : ''}`}>
                <div className="global--mobile-menu__header">
                    <a href="/">
                        <img className='header-logo' src="./images/synaptiq-icon-white.svg" alt="Synaptiq Icon" />
                    </a>
                    <button onClick={this.props.closeMenu} className="menu-button global--mobile-menu__header__close">
                        <img src="./images/icons/x.svg" alt="" />
                    </button>
                </div>
                <a className="global--mobile-menu__link" href="/">Home</a>
                <a className="global--mobile-menu__link" href="https://www.oraai.com" target="_blank" rel="noopener noreferrer">Ora AI<img class="ext-link" src="./images/icons/external-link.svg" alt="external link"/></a>
                {/* <a className="global--mobile-menu__link" href="/enterprise">Enterprise</a> */}
                <a className="global--mobile-menu__link global--mobile-menu__link--active" href="/library">Library</a>
                {/* <a className="global--mobile-menu__link" href="/curator-apply">Apply</a> */}
                <a className="global--mobile-menu__link" href="/contact">Contact Us</a>
                <div className="button-wrapper">
                    <a href="https://www.synaptiq.app/" className="button-pl button--default button--default--white-outline" target="_blank" rel="noreferrer">Sign In</a>
                    <a href="https://www.synaptiq.app/users/sign_up" className="button-pl button--default button--default--signup-mobile" target="_blank" rel="noreferrer">Try for Free</a>
                </div>
            </div>
        );
    }
}
